export default "__VITE_ASSET__DKKbnOKY__"